module.exports = __webpack_public_path__ + "static/img/yunTilte2.d6a9908c.png";